import { useEffect, useState } from 'react'
import { db } from '../firebase'
import { firebaseCollections as collections } from '../constants'

export default function useSubscribeToRental (rental = null) {
  const [loading, setLoading] = useState(true)
  const [ newRental, setNewRental ] = useState(rental)
  const [error, setError ] = useState(null)
  const rentalId = rental?.id
  let unsubscribe = () => {}

  useEffect(() => {
    try {
      if (rentalId) {
        setLoading(true)
        unsubscribe = db.collection(collections.rentals)
        .doc(rentalId)
        .onSnapshot(async doc => {
          let updatedRental = { id: doc.id, ...doc.data() }
          setNewRental({ ...rental, ...updatedRental })
          setLoading(false)
        })
      } else {
        setNewRental(null)
      }
    } catch (e) {
      setError(e)
    }
    return () => {
      unsubscribe()
    }
  }, [rentalId])

  return { unsubscribe, error, loading, rental: newRental }
}
